module.exports = __webpack_public_path__ + "static/bg-start15or20-mobile-76605a0695ffc9167ec2d3362c41d04d.jpg";